import { Row, Col } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {
  FooterSection,
  Title,
  NavLink,
  Extra,
  LogoContainer,
  Para,
  Large,
  Chat,
  Empty,
  FooterContainer,
  Language,
  Label,
  LanguageSwitch,
  LanguageSwitchContainer,
} from "./styles";

interface SocialLinkProps {
  href: string;
  src: string;
}

const Footer = ({ t }: { t: TFunction }) => {
  const handleChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const SocialLink = ({ href, src }: SocialLinkProps) => {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        key={src}
        aria-label={src}
      >
        <SvgIcon src={src} width="25px" height="25px" />
      </a>
    );
  };

  const scrollTo = () => {
    const element = document.getElementById("contact") as HTMLDivElement;
    if (element) {
      const offset = 50;
      const elementPosition =
        element.getBoundingClientRect().top + window.pageYOffset;

      window.scrollTo({
        top: elementPosition - offset,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <FooterSection>
        <Container>
          <Row justify="space-between" align="middle" style={{ paddingBottom: "2rem", borderBottom: "1px solid rgb(241, 242, 243)" }}>
            <Col lg={10} md={10} sm={24} xs={24}>
              <NavLink to="/">
                <LogoContainer>
                  <SvgIcon
                    src="lattice.png"
                    aria-label="homepage"
                    width="auto"
                    height="60"
                  />
                </LogoContainer>
              </NavLink>
              <Para style={{ marginTop: "1rem", fontSize: "16px", lineHeight: "1.6" }}>
                {t("Reviewing your Policies, Processes, and People practices? Let's connect.")}
              </Para>
            </Col>

            <Col lg={12} md={12} sm={24} xs={24}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '1rem' }}>
                <Language style={{ marginBottom: "0.5rem" }}>{t("Get in Touch")}</Language>

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <a href="mailto:connect@hrlattice.com" style={{ fontSize: '18px', color: '#18216d', fontWeight: 500 }}>
                    connect@hrlattice.com
                  </a>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                  <a href="tel:+919347490558" style={{ fontSize: '20px', color: '#18216d', fontWeight: 600 }}>
                    +91 9347490558
                  </a>
                  <a
                    href="https://wa.me/9347490558"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      background: '#25D366',
                      color: 'white',
                      padding: '5px 12px',
                      borderRadius: '20px',
                      fontSize: '14px',
                      fontWeight: 600
                    }}
                  >
                    <SvgIcon src="whatsapp.svg" width="16px" height="16px" />
                    WhatsApp
                  </a>
                </div>

                <div style={{ marginTop: '0.5rem' }}>
                  <Para style={{ width: "100%", margin: 0 }}>Flat No.108, SV Nagar, Banjara Hills road no.14, Hyderabad, Telangana</Para>
                </div>
              </div>
            </Col>
          </Row>

          <Row justify="space-between" align="middle" style={{ paddingTop: "2rem" }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              <LanguageSwitchContainer>
                <LanguageSwitch onClick={() => handleChange("en")}>
                  <SvgIcon src="united-states.svg" aria-label="homepage" width="30px" height="30px" />
                </LanguageSwitch>
                <LanguageSwitch onClick={() => handleChange("es")}>
                  <SvgIcon src="spain.svg" aria-label="homepage" width="30px" height="30px" />
                </LanguageSwitch>
              </LanguageSwitchContainer>
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              <FooterContainer>
                <SocialLink href="https://www.instagram.com/hr_lattice/" src="instagram.png" />
                <SocialLink href="https://x.com/HRLattice" src="twitter.png" />
                <SocialLink href="https://www.linkedin.com/company/hr-lattice/" src="linkedin.svg" />
                <SocialLink href="https://www.youtube.com/channel/UCy5DnXCIb--ftyTeaFKbbfQ" src="youtube.png" />
              </FooterContainer>
            </Col>
          </Row>
        </Container>
      </FooterSection>
    </>
  );
};

export default withTranslation()(Footer);
